import FaqBanner from './FaqBanner';
import FaqSection from './FaqSection';

function Faq() {
  return (
    <div>
      <FaqBanner />
      <FaqSection />
    </div>
  );
}

export default Faq;